import ReactDOM from 'react-dom/client';
import { App } from './App.tsx';
import i18n from './i18n/i18n.ts';
import './styles/index.scss';
import './styles/pages.scss';

// add destyling used to reset browser styles
import 'destyle.css/destyle.min.css';
import { ToastContainer } from 'react-toastify';
import { initEnvironment } from 'shared/src/environment.ts';
import { AuthProvider, AuthProviderProps } from 'react-oidc-context';
import { Log, WebStorageStateStore } from 'oidc-client-ts';

initEnvironment({
  i18n,
  selectedOffices: window.localStorage.getItem('sami_selected_offices')?.split(',') || [],
});

export const oidcConfig: AuthProviderProps = {
  authority: import.meta.env.VITE_KEYCLOAK_AUTHORITY,
  client_id: import.meta.env.VITE_KEYCLOAK_CLIENT,
  redirect_uri: window.location.origin + '/',
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid profile email',
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname + '/');
  },
};
Log.setLogger(console);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <AuthProvider {...oidcConfig}>
    <ToastContainer />
    {/* <React.StrictMode> */}
    <App />
    {/* </React.StrictMode> */}
  </AuthProvider>,
);
